export default function remove(name, domain) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;" + (domain ? "domain=" + domain + ";" : "");
}
